module.exports = {
  ...require('./logger'),
  ...require('./success-rate-methods'),
};
